var _path, _rect, _path2, _path3, _path4, _path5, _path6, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFastlane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,70.75H40A2.7528,2.7528,0,0,0,42.75,68V52.38239a16.75,16.75,0,1,0,0-24.76478V12A2.7528,2.7528,0,0,0,40,9.25H12A2.7528,2.7528,0,0,0,9.25,12V68A2.7528,2.7528,0,0,0,12,70.75Zm42-46a15.25061,15.25061,0,1,1-10.7832,4.4668A15.14934,15.14934,0,0,1,54,24.75ZM10.75,12A1.25116,1.25116,0,0,1,12,10.75H40A1.25116,1.25116,0,0,1,41.25,12V29.15515a16.70135,16.70135,0,0,0,0,21.6897V68A1.25116,1.25116,0,0,1,40,69.25H12A1.25116,1.25116,0,0,1,10.75,68Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 15.25,
    width: 8,
    height: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26,59.25A2.75,2.75,0,1,0,28.75,62,2.7528,2.7528,0,0,0,26,59.25Zm0,4A1.25,1.25,0,1,1,27.25,62,1.25116,1.25116,0,0,1,26,63.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26,34.81787a10.21151,10.21151,0,0,1,7.456,3.26123l1.0879-1.03222a11.6525,11.6525,0,0,0-17.0879,0L18.544,38.0791A10.21151,10.21151,0,0,1,26,34.81787Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.12305,39.85889l1.08789,1.03222a6.51979,6.51979,0,0,1,9.57812,0L31.877,39.85889a8.01839,8.01839,0,0,0-11.7539,0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.78906,42.67139,23.877,43.70361a2.95208,2.95208,0,0,1,4.2461,0l1.08789-1.03222a4.38447,4.38447,0,0,0-6.42188,0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.46,46.53955a9.24521,9.24521,0,0,1,12.52368-13.5838l-4.65259,4.65271A2.71644,2.71644,0,0,0,54,37.25,2.75,2.75,0,1,0,56.75,40a2.71616,2.71616,0,0,0-.3584-1.331l8.13867-8.13874-1.06054-1.06054L61.04419,31.8952A10.74319,10.74319,0,0,0,46.39941,47.6001ZM54,41.25A1.25,1.25,0,1,1,55.25,40,1.25116,1.25116,0,0,1,54,41.25Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 45.87238,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFastlane);
export default __webpack_public_path__ + "static/media/icon_fastlane.73d08affda57fc9c9f30e4ce46d475e3.svg";
export { ForwardRef as ReactComponent };